export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10799.44d1d01f.jpg";